var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-sfc"},[(_vm.loaded)?_c(_vm.customComponent.sfc_name,{key:_vm.key,tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }